import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectCrossClientFilteredResults, selectCrossClientResultsExecution } from '../../../store/crossClient/crossClientResults'
import { ZocksDataTable } from '../../../components/DataTable/ZocksDataTable'
import { TableColumn, TableStyles } from 'react-data-table-component'
import { CrossClientQueryResultDisplay } from '../../../models/CrossClient'
import { CrossClientQueryResultMatchCell } from './Cells/CrossClientQueryResultMatchCell'
import { CrossClientQueryResultButtonsCell } from './Cells/CrossClientQueryResultButtonsCell'
import { CrossClientQueryResultClientCell } from './Cells/CrossClientQueryResultClientCell'
import { CrossClientQueryResultOwnerCell } from './Cells/CrossClientQueryResultOwnerCell'
import { useSortCrossClientResults } from '../Results/hooks'
import './CrossClientTable.scss'

const TABLE_STYLES: TableStyles = {
  table: {
    style: {
      border: '1px solid var(--zocks-gray-300)',
      borderRadius: '1rem',
    },
  },
  headRow: {
    style: {
      background: 'var(--zocks-gray-200)',
      borderRadius: '1rem  1rem 0 0',
    },
  },
  headCells: {
    style: {
      color: 'var(--zocks-gray-700)',
      textTransform: 'uppercase',
      fontWeight: '700',
    },
  },
  rows: {
    style: {
      animation: 'row-in 0.4s ease-out forwards',
    },
  },
  noData: {
    style: {
      borderRadius: '1rem',
    },
  },
}

export const CrossClientTable = () => {
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const results = useAppSelector(selectCrossClientFilteredResults)

  const { sortCrossClientResultsByClient, sortCrossClientResultsByOwner, sortCrossClientResultsByMatch } = useSortCrossClientResults()

  const { decomposition } = execution ?? {}

  if (!decomposition) {
    return <div>No decomposition</div> // todo
  }

  const columns: TableColumn<CrossClientQueryResultDisplay>[] = [
    {
      selector: (row) => row.clientId,
      name: 'Client',
      sortable: true,
      sortFunction: sortCrossClientResultsByClient,
      grow: 21,
      cell: (row) => <CrossClientQueryResultClientCell result={row} />,
    },
    {
      name: 'Owner',
      sortable: true,
      sortFunction: sortCrossClientResultsByOwner,
      grow: 16,
      cell: (row) => <CrossClientQueryResultOwnerCell result={row} />,
    },
    {
      name: 'Match',
      sortable: true,
      sortFunction: sortCrossClientResultsByMatch,
      grow: 5.5,
      cell: (row) => <CrossClientQueryResultMatchCell result={row} decomposition={decomposition} />,
    },
    {
      ignoreRowClick: true,
      grow: 6,
      center: true,
      cell: (row) => <CrossClientQueryResultButtonsCell result={row} />,
    },
  ]

  return (
    <ZocksDataTable
      columns={columns}
      data={results}
      customStyles={TABLE_STYLES}
      pagination
      highlightOnHover={false}
      className='cross-client-table'
      defaultSortFieldId={1}
      paginationPerPage={20}
    />
  )
}
